<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  toolBar
  .content-center
    Marquee
    //- MainSlider(v-if="!whiteLabel")
    template(v-if="!whiteLabel")
      .swiper-container.lobby-swiper
        template(v-if="language == 'cn'")
          iframe(src='https://banner.wbmarketingtools.com/cn/' allowtransparency='true')
        template(v-else)
          iframe(src='https://banner.wbmarketingtools.com/en/' allowtransparency='true')
        img.img-fluid(src='images/slider/transparent-slider-height.png')
    div
      .lobby
        template(v-if="!whiteLabel")
          .swiper-container-lobby-thumb
            .lobby-title
              | {{ $t("ui.sports") }}
            .swiper-wrapper
              //- .swiper-slide.thumbnail
              //-   a(href="javascript:void(0);" @click='setMenu0("2", getEventDate("2024-06-14T21:00:00"))')
              //-     img.img-fluid(:src='getImgUrl("sport-euro24.png?v=12")')
              //-     .caption.text-ellipsis {{ $t("ui.event_euro") }} 
              .swiper-slide.thumbnail(v-if="$store.getters.currencyCode == 'BDT'")
                a(href="javascript:void(0);" @click='setMenu2x(12)')
                  img.img-fluid(:src='getImgUrl("sport-cricket.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[12] }}
              .swiper-slide.thumbnail
                a(href="javascript:void(0);" @click='setMenu2x(1)')
                  img.img-fluid(:src='getImgUrl("sport-soccer.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[1] }}
              .swiper-slide.thumbnail
                a(href="javascript:void(0);" @click='setMenu2x(43)')
                  img.img-fluid(:src='getImgUrl("lobby_vgames.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.egames") }}
              .swiper-slide.thumbnail
                a(href="javascript:void(0);" @click='setMenu2x(2)')
                  img.img-fluid(:src='getImgUrl("sport-basketball.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[2] }}
              .swiper-slide.thumbnail(v-if="!whiteLabel && esports2")
                router-link(to="/slots?mode=3" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("sport-esport.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[20] }}
              .swiper-slide.thumbnail
                a(href="javascript:void(0);" @click='setMenu2x(7)')
                  img.img-fluid(:src='getImgUrl("sport-tennis.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[7] }}
              .swiper-slide.thumbnail
                a(href="javascript:void(0);" @click='setMenu2x(4)')
                  img.img-fluid(:src='getImgUrl("sport-tabletennis.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[4] }}
              .swiper-slide.thumbnail
                a(href="javascript:void(0);" @click='setMenu2x(9)')
                  img.img-fluid(:src='getImgUrl("sport-icehockey.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[9] }}
              .swiper-slide.thumbnail
                a(href="javascript:void(0);" @click='setMenu2x(11)')
                  img.img-fluid(:src='getImgUrl("sport-volleyball.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[11] }}
            .swiper-pagination-thumb(:slot="'pagination'")
          .swiper-container-lobby-thumb
            .lobby-title
              | {{ $t("ui.casino") }}
            .swiper-wrapper
              //- .swiper-slide.thumbnail(v-if="!mmoMode && ['MYR', 'SGD', 'THB', 'VND', 'IDR', 'CNY', 'USD'].includes($store.getters.currencyCode)")
              //-   router-link(to="/casino?suite=10" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
              //-     img.img-fluid(:src='getImgUrl("casino-pragmatic.png?v=12")')
              //-     .caption.text-ellipsis {{ $t("ui.suite_pp-c") }}
              .swiper-slide.thumbnail(v-if="!mmoMode")
                router-link(to="/casino?suite=12" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-sexy.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_sexy") }}
              .swiper-slide.thumbnail(v-if="!mmoMode")
                router-link(to="/casino?suite=11" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-ai.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_ai") }}
              .swiper-slide.thumbnail
                router-link(to="/casino?suite=9" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-yeebet.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_yb") }}
              .swiper-slide.thumbnail(v-if="!brand")
                router-link(to="/casino?suite=4" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-ct855.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_ct855") }}
              .swiper-slide.thumbnail(v-if="!mmoMode")
                router-link(to="/casino?suite=1" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-gameplay.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_gp") }}
              .swiper-slide.thumbnail(v-if="!brand")
                router-link(to="/casino?suite=3" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-sagaming.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_sa") }}
              .swiper-slide.thumbnail(v-if="!mmoMode && !brand")
                router-link(to="/casino?suite=8" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-evo.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_evo") }}
              .swiper-slide.thumbnail(v-if="!mmoMode")
                router-link(to="/casino?suite=7" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("casino-pg.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.suite_pg") }}
            .swiper-pagination-thumb(:slot="'pagination'")
          .swiper-container-lobby-thumb
            .lobby-title
              | {{ $t("ui.slots") }}
            .swiper-wrapper
              template(v-if="['SGD', 'CNY', 'IDR', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=13" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-epw.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_epw") }}  
              template(v-if="['SGD', 'CNY', 'IDR', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=12" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-wf.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_wf") }} 
              template(v-if="['SGD', 'CNY', 'IDR', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)") 
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=11" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-wow.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_wow") }}
              .swiper-slide.thumbnail
                router-link(to="/slots?mode=0" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("slot-live22.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.slot_live22") }}
              template(v-if="['SGD', 'CNY', 'IDR', 'VND', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=7" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-uusl.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_uusl") }}
              template(v-if="!mmoMode && ['MYR', 'THB', 'USD', 'MMK', 'MMO', 'CNY', 'IDR', 'SGD'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=9" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-dbhash.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_dbhash") }}
              template(v-if="!['MYR','SGD'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=1" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-pgs.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_pgs") }}
              template(v-if="['SGD', 'CNY', 'IDR', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=8" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-next.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_next") }} 
              template(v-if="!mmoMode && ['MYR', 'SGD', 'THB', 'VND', 'IDR', 'CNY', 'USD'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=2" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-ppg.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_ppg") }}
              template(v-if="!mmoMode && ['MYR', 'THB', 'IDR', 'CNY', 'USD'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=4" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-jkr.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_jkr") }}
              template(v-if="!mmoMode && ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'VND'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=5" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-spp.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_spp") }}
              template(v-if="!mmoMode && ['MYR', 'THB', 'USD'].includes($store.getters.currencyCode)")
                .swiper-slide.thumbnail
                  router-link(to="/slots?mode=6" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("slot-jili.png?v=12")')
                    .caption.text-ellipsis {{ $t("ui.slot_jili") }}
            .swiper-pagination-thumb(:slot="'pagination'")
          .swiper-container-lobby-thumb.poker(v-if="!mmoMode && ['MYR', 'THB', 'USD', 'MMK', 'MMO', 'CNY', 'IDR', 'SGD'].includes($store.getters.currencyCode)")
            .lobby-title
              | {{ $t("ui.poker") }}
            .swiper-wrapper
              //- template(v-if="!mmoMode && ['MYR', 'THB', 'USD', 'MMK', 'MMO', 'CNY', 'IDR', 'SGD'].includes($store.getters.currencyCode)")
              .swiper-slide.thumbnail
                router-link(to="/slots?mode=10" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  img.img-fluid(:src='getImgUrl("poker-db.png?v=12")')
                  .caption.text-ellipsis {{ $t("ui.poker_db") }}
          template(v-if="!mmoMode")
            //- .swiper-container-lobby-thumb.arcade
            //-   .lobby-title
            //-     | {{ $t("ui.mini_arcade") }}
            //-   .swiper-wrapper
            //-     .swiper-slide.thumbnail
            //-       a(href="javascript:void(0);" data-toggle='modal' data-target='#minigame')
            //-         img.img-fluid(:src='getImgUrl("slot-miniarcade.png?v=12")')
            //-         .caption.text-ellipsis Arcadia Gaming
            //-   .swiper-pagination-thumb(:slot="'pagination'")
            .swiper-container-lobby-thumb
              .lobby-title
                | {{ $t("ui.fishing") }}
              .swiper-wrapper
                .swiper-slide.thumbnail
                  router-link(to="/slots?gameID=830009" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("en/fishingwar.png?v=12")')
                    .caption.text-ellipsis Fishing War
                .swiper-slide.thumbnail
                  router-link(to="/slots?gameID=830014" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("en/slashfruit.png?v=12")')
                    .caption.text-ellipsis Slash Fruit
                .swiper-slide.thumbnail
                  router-link(to="/slots?gameID=830013" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("en/happyfish.png?v=12")')
                    .caption.text-ellipsis Happy Fish
                .swiper-slide.thumbnail
                  router-link(to="/slots?gameID=830012" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("en/legendofphoenix.png?v=12")')
                    .caption.text-ellipsis Legend of the Phoenix
                .swiper-slide.thumbnail
                  router-link(to="/slots?gameID=830010" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("en/themonkeyking2.png?v=12")')
                    .caption.text-ellipsis The Monkey King 2
                .swiper-slide.thumbnail
                  router-link(to="/slots?gameID=830011" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                    img.img-fluid(:src='getImgUrl("en/goddefense.png?v=12")')
                    .caption.text-ellipsis God Defense
                template(v-if="['MYR', 'THB', 'USD'].includes($store.getters.currencyCode)")
                  template(v-if="gamelist")
                    .swiper-slide.thumbnail(v-for="game in gamelist" :key="'game_id_'+game.GameId")
                      router-link(:to="'/slots?mode=6&gameID=' + game.GameId" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                        img.img-fluid(:src="'https://r.myw0011001.com/mobile/lobby-thumb/jili/jili_' + game.GameId + '.png?v=12'")
                        .caption.text-ellipsis {{ game.name["en-US"] }}
              .swiper-pagination-thumb(:slot="'pagination'")
        template(v-else)
          .row.m-0
            //- .col-4.p-0
            //-   .thumbnail.m-1
            //-     a(href="javascript:void(0);" @click='setMenu0(1)')
            //-       img.img-fluid(:src='getImgUrl("sport-euro20.png?v=12')
            //-       .caption.text-ellipsis {{ $t("ui.euro") }}
            .col-4.p-0
              .thumbnail.m-1
                a(href="javascript:void(0);" @click='setMenu2x(1)')
                  img.img-fluid(:src='getImgUrl("sport-soccer.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[1] }}
            .col-4.p-0
              .thumbnail.m-1
                a(href="javascript:void(0);" @click='setMenu2x(2)')
                  img.img-fluid(:src='getImgUrl("sport-basketball.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[2] }}
            .col-4.p-0
              .thumbnail.m-1
                a(href="javascript:void(0);" @click='setMenu2x(20)')
                  img.img-fluid(:src='getImgUrl("sport-esport.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[20] }}
          .row.m-0
            .col-4.p-0
              .thumbnail.m-1
                a(href="javascript:void(0);" @click='setMenu2x(7)')
                  img.img-fluid(:src='getImgUrl("sport-tennis.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[7] }}
            .col-4.p-0
              .thumbnail.m-1
                a(href="javascript:void(0);" @click='setMenu2x(4)')
                  img.img-fluid(:src='getImgUrl("sport-tabletennis.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[4] }}
            .col-4.p-0
              .thumbnail.m-1
                a(href="javascript:void(0);" @click='setMenu2x(9)')
                  img.img-fluid(:src='getImgUrl("sport-icehockey.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[9] }}
          .row.m-0
            .col-4.p-0
              .thumbnail.m-1
                a(href="javascript:void(0);" @click='setMenu2x(11)')
                  img.img-fluid(:src='getImgUrl("sport-volleyball.png?v=12")')
                  .caption.text-ellipsis {{ sportsName[11] }}

  footerNav
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import config from "@/config";
import toolBar from "@/components/mobile/toolBar";
// import debugTable from "@/components/mobile/debugTable";
import footerNav from "@/components/mobile/footerNav";
import MainSlider from "@/components/mobile/mainPanelControl/mainSlider";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import xhr from "@/library/_xhr-game.js";
import mixinMain from "@/library/mixinMain";

export default {
  components: {
    toolBar,
    // debugTable,
    footerNav,
    MainSlider,
    Marquee
  },
  mixins: [mixinMain],
  data() {
    return {
      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 3,
        loop: false,
        pagination: {
          el: ".swiper-pagination-thumb",
          clickable: true
        },
      },
      gamelist: [],
    };
  },
  computed: {
    brand() {
      return config.brand == "IBCBET";
    },
    debugMode() {
      return config.debugMode;
    },
    sportsName() {
      return this.$store.state.layout.sports;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    esports2() {
      return config.esports2 == "1";
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    language() {
      return this.$store.getters.language;
    }
  },
  created() {
    this.launchJILIGameList(true);
  },
  mounted() {
    var swiper2 = new Swiper('.swiper-container-lobby-thumb', {
        spaceBetween: 10,
        slidesPerView: 3,
        centeredSlides: false,
        loop: true,
        pagination: {
          el: '.swiper-pagination-thumb',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    if(!this.mmoMode) {
      var swiper3 = new Swiper('.swiper-container-lobby-thumb.poker', {
          spaceBetween: 10,
          slidesPerView: 3,
          centeredSlides: false,
          loop: true,
          pagination: {
            el: '.swiper-pagination-thumb',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
      });
      swiper3.loopDestroy();
    }
  },
  methods: {
    getImgUrl(e) {
      return config.resourceImgUrl + '/mobile/lobby-thumb/' + e;
    },
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    setMenu2x(mode) {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = ![1].includes(mode) ? "all" : "live";
      mi5["menu1"] = ![1].includes(mode) ? "today" : "live";
      // mi5["menu0"] = "all";
      // mi5["menu1"] = "today";
      mi5["menu2"] = parseInt(mode);
      mi5["menu3"] = "hdpou";

      var options = {};
      options[mi5["menu2"]] = true;
      this.$store.dispatch("layout/setOptions", { property: "live", value: options });
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE");
      this.$router.push("/prematch");
    },
    setMenu0(e, m, bt) {
      if (EventBus.setMenu0) {
        if(bt == 'orz') {
          EventBus.setMenu0('event', e, m, bt);
        } else {
          EventBus.setMenu0('event', e, m);
        }
      }

      // var mi5 = {};
      // mi5["menuX"] = false;
      // mi5["menuY"] = event;
      // mi5["menu0"] = "event";
      // mi5["menu1"] = market == null ? "today" : market;
      // mi5["menu2"] = parseInt(mode);
      // mi5["menu3"] = "hdpou";
      // var options = {};
      // options[mi5["menu2"]] = true;
      // this.$store.dispatch("layout/setMenuItems", mi5);
      // EventBus.$emit("INVALIDATE");
      // this.$router.push("/prematch");
    },
    getEventDate(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? "today" : "early";
    },
    getEventDate2(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? null : "orz";
    },
    launchJILIGameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken
      };

      xhr.launchJILIGameList(args).then(
        res => {
          // this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (res.data.length > 0) {
                // this.gamelist = res.data;
                const filteredList = res.data.filter(obj => obj.GameCategoryId === 5);
                this.gamelist = filteredList;
                // console.log(this.gamelist);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          // this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    }
  }
};
</script>
